<template>
  <div class="seasidetms_dynamic_cart_wrap">
    <div class="seasidetms_dynamic_cart">
      <a href="javascript:void(0)" class="seasidetms_dynamic_cart_button">
        <span class="count_wrap seasidetms_icon_custom_cart_1">
          <span class="count seasidetms_dynamic_cart_count">
            {{ cart.qty }}
          </span>
        </span>
      </a>
      <div class="seasidetms_cart_info">
        <p>{{ $t('cart') }}</p>
        <p class="seasidetms_subtotal_shop">
          <span>
            <span class="woocommerce-Price-amount amount">
              <span>
                <span class="woocommerce-Price-currencySymbol">₴</span>
              </span>
              {{ cart.price }}
            </span>
          </span>
        </p>
      </div>
      <div
        class="widget_shopping_cart_content"
        style="opacity: 1"
        v-if="cart.qty"
      >
        <ul class="woocommerce-mini-cart cart_list product_list_widget">
          <li
            v-for="(item, i) in cartItems"
            :key="`cartitem-${i}`"
            class="woocommerce-mini-cart-item mini_cart_item"
          >
            <div v-if="item.isProfit" style="padding-left: 25px">
              <router-link
                :to="lang ? '/' + lang + item.link : item.link"
                @click.native="onClickProdcut(item, i)"
              >
                <img
                  width="270"
                  height="270"
                  class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                  :src="productImg(item)"
                  :alt="productName(item)"
                />
                {{ productName(item) }}
              </router-link>
              <span class="quantity">
                {{ item.qty }}
                ×
                <span class="woocommerce-Price-amount amount">
                  <span>
                    <span class="woocommerce-Price-currencySymbol">₴</span>
                  </span>
                  {{ productPrice(item) }}
                </span>
              </span>
            </div>
            <div v-else>
              <a
                href="#"
                class="remove remove_from_cart_button"
                :aria-label="$t('removePosition')"
                @click.stop.prevent="onRemoveItem(item)"
              >
                ×
              </a>
              <router-link :to="lang ? '/' + lang + item.link : item.link">
                <img
                  width="540"
                  height="540"
                  class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail"
                  :src="productImg(item)"
                  :alt="productName(item)"
                />
                {{ productName(item) }}
              </router-link>
              <span class="quantity">
                {{ item.qty }}
                ×
                <span class="woocommerce-Price-amount amount">
                  <span>
                    <span class="woocommerce-Price-currencySymbol">₴</span>
                  </span>
                  {{ productPrice(item) }}
                </span>
              </span>
            </div>
          </li>
        </ul>
        <p class="woocommerce-mini-cart__total total">
          <strong>{{ $t('totalPrice') }}</strong>
          <span class="woocommerce-Price-amount amount">
            <span>
              <span class="woocommerce-Price-currencySymbol">₴</span>
            </span>
            {{ cart.price }}
          </span>
        </p>
        <p class="woocommerce-mini-cart__buttons buttons">
          <router-link
            :to="lang ? '/' + lang + '/cart' : '/cart'"
            class="button wc-forward another-btn"
          >
            {{ $t('viewCart') }}
          </router-link>
          <router-link
            :to="lang ? '/' + lang + '/checkout' : '/checkout'"
            class="button checkout wc-forward another-btn"
          >
            {{ $t('checkoutOrder') }}
          </router-link>
        </p>
      </div>
      <div class="widget_shopping_cart_content" v-else>
        <p class="woocommerce-mini-cart__empty-message">
          {{ $t('cartEmpty') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CartMixin from '@/components/cart/CartMixin'

export default {
  name: 'MiniCart',
  mixins: [CartMixin],
  computed: {
    cartItems() {
      let a = []
      this.cart.items.forEach((item) => {
        a.push(item)
        if (
          Array.isArray(item.profitableKit) &&
          item.profitableKit.length > 1
        ) {
          a.push(
            this.makeProfitItem(item.profitableKit[0], item.qty, item.kitDisc)
          )
          a.push(
            this.makeProfitItem(item.profitableKit[1], item.qty, item.kitDisc)
          )
        }
      })
      return a
    },
  },
  methods: {
    productPrice(product) {
      return product.newPrice ? product.newPrice : product.price
    },
  },
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style></style>
